import { Edit, RestartAlt } from '@mui/icons-material';
import {
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  IconButton,
  TextField,
  Typography,
} from '@mui/material';
import { getCompanyConfigOld } from 'lib/api/company';
import { createExpressFactoringRequest } from 'lib/api/express';
import { expressGetCompanyConfig } from 'lib/api/express/company';
import CustomButton from 'lib/designSystem/Button';
import CenteredCircularProgress from 'lib/designSystem/CircularProgress';
import { LightTooltip } from 'lib/designSystem/WhiteTooltip';
import {
  formatDate,
  hasAnyPermissions,
  showAlert,
  validateCompanyTypes,
  validatePermissions,
} from 'lib/functions/utils';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { AuthState } from '../../../../../../../services/redux/authSlice';
import DateSelector from './components/Step1';

const ShoppingCartFactoring = (props: any) => {
  const {
    business,
    selectedDocuments,
    setSelectedDocuments,
    openShoppingCart,
    setOpenShoppingcart,
    setContinueToSimulation,
    setSelectedRequest,
    subProductSelected,
    subProduct,
    setOpenDocumentsSelector,
    setBackwards,
    backwards,
  } = props;
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);

  const [requestPayers, setRequestPayers] = useState<any>([]);
  const [canForcePaymentDate, setCanForcePaymentDate] = useState(false);
  const [fileStatusMandatory, setFileStatusMandatory] = useState(false);
  const [minimumDays, setMinimumDays] = useState(15);
  const [loading, setLoading] = useState(false);
  const [tempPaymentDateRows, setTempPaymentDateRows] = useState<any[]>(
    new Array(selectedDocuments.length).fill(null),
  );
  const [tempSubDocumentPaymentDateRows, setTempSubDocumentPaymentDateRows] =
    useState<any[]>(new Array(selectedDocuments.length).fill([]));
  const dispatch = useDispatch();
  const [confirmOperationDateNotToday, setConfirmOperationDateNotToday] =
    useState(false);
  const newOperationDate = new Date();
  const [confirmCreditNotesDiscount, setConfirmCreditNotesDiscount] =
    useState(false);
  newOperationDate.setUTCHours(12);
  const [operationDate, setOperationDate] = useState(newOperationDate);

  const handleCloseDialog = () => {
    setOpenShoppingcart(false);
  };

  const createSelectedRequestObject = () => {
    const documents = selectedDocuments.flatMap((document: any) => {
      if (document.subDocuments?.length) {
        // Solo hijos
        return document.subDocuments.map((subDocument: any) => ({
          id: subDocument.id,
          amount: subDocument.amount,
          amountDocument: 0,
          amountFinanced: 0,
          amountRetention: 0,
          businessIdentifier: subDocument.businessIdentifier,
          issuedDate: subDocument.issuedDate,
          receiptDate: subDocument.receiptDate || subDocument.issuedDate,
          confirmDate: document.confirmDate,
          daysToCount: subDocument.daysToCount,
          folio: `${document.folio}-${subDocument.folio}`,
          subProductName: subProduct?.name,
          paymentDate: subDocument.paymentDate,
          cancelDate: subDocument.cancelDate,
          stakeholderName: subDocument.stakeholderName,
          stakeholderIdentifier: subDocument.stakeholderIdentifier,
          fatherDocumentId: document.id,
          code: subDocument.code,
          active: true,
        }));
      } else {
        // Solo padre (sin hijos)
        return [
          {
            id: document.id,
            amount: document.amount,
            amountDocument: 0,
            amountFinanced: 0,
            amountRetention: 0,
            businessIdentifier: document.businessIdentifier,
            issuedDate: document.issuedDate,
            receiptDate: document.receiptDate || document.issuedDate,
            daysToCount: document.daysToCount,
            confirmDate: document.confirmDate,
            cedded: 'No cedido',
            folio: document.folio,
            paymentDate: document.paymentDate,
            subProductName: subProduct?.name,
            cancelDate: document.cancelDate,
            stakeholderName: document.stakeholderName,
            stakeholderIdentifier: document.stakeholderIdentifier,
            active: true,
            code: document.code,
          },
        ];
      }
    });

    const fatherDocumentWithChildren = selectedDocuments.filter(
      (document: any) => document.subDocuments?.length,
    );
    const documentsToUpdate = fatherDocumentWithChildren.map(
      (document: any) => ({
        id: document.id,
        amount: document.amount,
        amountDocument: 0,
        amountFinanced: 0,
        amountRetention: 0,
        businessIdentifier: document.businessIdentifier,
        issuedDate: document.issuedDate,
        daysToCount: document.daysToCount,
        confirmDate: document.confirmDate,
        cedded: 'No cedido',
        folio: document.folio,
        paymentDate: document.paymentDate,
        subProductName: subProduct?.name,
        cancelDate: document.cancelDate,
        stakeholderName: document.stakeholderName,
        stakeholderIdentifier: document.stakeholderIdentifier,
        active: true,
        code: document.code,
      }),
    );

    const request = {
      id: null,
      advance: 0,
      rate: 0,
      businessIdentifier: documents[0].businessIdentifier,
      businessName: business?.businessName,
      amount: documents.reduce((acc: any, curr: any) => acc + curr.amount, 0),
      amounToApply: 0,
      operationCost: 0,
      status: 'Creando',
      subProduct: subProductSelected || 'electronic-invoice',
      subProductName: subProduct?.name,
      documents: documents,
      documentsToUpdate: documentsToUpdate,
      requestDate: operationDate,
      x: 'aaa',
    };
    setSelectedRequest(request);
    return request;
  };

  const validateDocumentsAndSubDocuments = () => {
    const duplicatedFolios: string[] = [];
    selectedDocuments.forEach((document: any) => {
      if (!document.oldSubDocuments) return;
      if (document.subDocuments?.length) {
        const subFolios = document.oldSubDocuments.map(
          (subDocument: any) => subDocument.folio,
        );
        document.subDocuments.forEach((subDocument: any) => {
          const key = `${document.folio}-${subDocument.folio}`;
          if (subFolios.includes(key)) {
            duplicatedFolios.push(key);
          }
        });
      }
    });
    if (duplicatedFolios.length) {
      alert(`Ya existen algunos sub folios. ${duplicatedFolios.join(', ')}`);
      return false;
    }

    const paymentDate = selectedDocuments.every((document: any) => {
      if (document.subDocuments?.length) {
        return document.subDocuments.every((subDocument: any) => {
          return subDocument.paymentDate;
        });
      } else {
        return document.paymentDate;
      }
    });
    if (!paymentDate) {
      showAlert(dispatch, 'error', 'Por favor, complete las fechas de pago');
      return false;
    }
    const amount = selectedDocuments.every((document: any) => {
      if (document.subDocuments?.length) {
        return document.subDocuments.every((subDocument: any) => {
          return subDocument.amount;
        });
      } else {
        return document.amount;
      }
    });
    if (!amount) {
      showAlert(dispatch, 'error', 'Por favor, complete los montos');
      return false;
    }
    const amountSubDocumentsLessThanFather = selectedDocuments.every(
      (document: any) => {
        if (document.subDocuments?.length) {
          const sumaSubDocs = document.subDocuments.reduce(
            (acc: any, curr: any) => acc + (curr.amount || 0),
            0,
          );
          if (sumaSubDocs > document.amount) {
            showAlert(
              dispatch,
              'error',
              `La suma de los montos de los subdocumentos (${sumaSubDocs}) no puede ser mayor al monto del documento padre (${document.amount}) para el folio ${document.folio}`,
            );
            return false;
          }
          return true;
        } else {
          return true;
        }
      },
    );
    if (!amountSubDocumentsLessThanFather) {
      showAlert(
        dispatch,
        'error',
        'El monto de los documentos no puede ser mayor al del padre',
      );
      return false;
    }
    return true;
  };

  const executeAccountantCreateRequest = async () => {
    if (!user?.clientId) return alert('No se ha podido obtener el usuario');
    if (!checkSelectedDocumentFileStatus()) {
      alert('Por favor, suba los PDF de las facturas en la solicitud.');
      return;
    }
    setLoading(true);
    try {
      const request = createSelectedRequestObject();
      await createExpressFactoringRequest(dispatch, user?.clientId, request);
      setOpenShoppingcart(false);
      showAlert(dispatch, 'success', 'Solicitud enviada con éxito');
      window.location.href = `/factoring/requests`;
    } catch (error) {
      showAlert(dispatch, 'error', 'Error al enviar la solicitud');
    }
    setLoading(false);
  };

  const operationDateNotToday = () => {
    return (
      operationDate?.toISOString().split('T')[0] !==
      new Date().toISOString().split('T')[0]
    );
  };

  const hasDocumentsWithCreditNotes = () => {
    return selectedDocuments.some((document: any) => {
      if (document.subDocuments?.length) {
        return document.subDocuments.some(
          (subDocument: any) =>
            subDocument.creditNoteAmount && subDocument.creditNoteAmount > 0,
        );
      } else {
        return document.creditNoteAmount && document.creditNoteAmount > 0;
      }
    });
  };

  const hasUnappliedCreditNotes = () => {
    return selectedDocuments.some((document: any) => {
      if (document.subDocuments?.length) {
        return document.subDocuments.some(
          (subDocument: any) =>
            subDocument.creditNoteAmount &&
            subDocument.creditNoteAmount > 0 &&
            !subDocument._creditNoteApplied,
        );
      } else {
        return (
          document.creditNoteAmount &&
          document.creditNoteAmount > 0 &&
          !document._creditNoteApplied
        );
      }
    });
  };

  const handleFoward = async () => {
    if (validateCompanyTypes(user, 'FactoringQuoting')) {
      if (!validateDocumentsAndSubDocuments()) {
        return;
      }
      if (operationDateNotToday() && !confirmOperationDateNotToday) {
        alert('Por favor, confirma que la fecha de solicitud no es hoy');
        return;
      }
      if (hasUnappliedCreditNotes() && !confirmCreditNotesDiscount) {
        alert(
          'Por favor, confirma que no deseas descontar las notas de crédito',
        );
        return;
      }
      createSelectedRequestObject();
      setContinueToSimulation();
      setOpenShoppingcart(false);
      return;
    } else if (validateCompanyTypes(user, 'Accountant')) {
      await executeAccountantCreateRequest();
      return;
    }
  };

  const handleBackwards = () => {
    if (validateCompanyTypes(user, 'Accountant')) {
      return setOpenShoppingcart(false);
    }
    setOpenDocumentsSelector(true);
    setOpenShoppingcart(false);
    setBackwards(true);
  };

  const stepChecker = () => {
    const paymentDaysValid = validatePaymentDays();
    const creditNotesValid =
      !hasUnappliedCreditNotes() || confirmCreditNotesDiscount;
    const subDocumentsValid = validateSubDocuments();
    return !paymentDaysValid || !creditNotesValid || !subDocumentsValid;
  };

  const validateSubDocuments = () => {
    const allSubDocumentsValid = selectedDocuments.every((document: any) => {
      if (!document.subDocuments) return true;
      const allSubDocumentsHaveFolio = document.subDocuments?.every(
        (subDocument: any) => {
          return subDocument.folio && subDocument.folio != '';
        },
      );
      const subDocumentsFolios = document.subDocuments.map(
        (subDocument: any) => subDocument.folio,
      );
      const subDocumentsFoliosSet = Array.from(new Set(subDocumentsFolios));
      const allSubdocumentsFoliosAreUnique =
        subDocumentsFoliosSet.length === subDocumentsFolios.length;
      return allSubDocumentsHaveFolio && allSubdocumentsFoliosAreUnique;
    });
    return allSubDocumentsValid;
  };

  const validatePaymentDays = () => {
    return selectedDocuments.every((document: any) => {
      if (document.subDocuments?.length) {
        return document.subDocuments.every((subDocument: any) => {
          return subDocument.paymentDate;
        });
      } else {
        return document.paymentDate;
      }
    });
  };

  const setUpRequestsInvoices = () => {
    const requestInvoicesArray = [];
    const payersObject: any = {};
    for (const document of selectedDocuments) {
      const paymentDate = document.paymentDate;
      const requestInvoice = {
        ...document,
        paymentDate,
        originalAmount: document.originalAmount ?? document.amount,
      };
      requestInvoicesArray.push(requestInvoice);
      if (!payersObject[requestInvoice.stakeholderIdentifier]) {
        payersObject[requestInvoice.stakeholderIdentifier] = {
          stakeholderName: requestInvoice.stakeholderName,
          paymentDays: null,
        };
      }
    }
    setSelectedDocuments(requestInvoicesArray);
    setRequestPayers(payersObject);
  };

  const setUp = async () => {
    setLoading(true);
    await fetchDateRestrictionsConfig();
    setUpRequestsInvoices();
    setLoading(false);
  };
  const getRestrictions = async () => {
    let system_operations_forcePaymentDate,
      system_operations_minimunDays,
      pruffConnect_operations_uploadPdfMandatory;
    if (user?.express) {
      if (!user.clientId) {
        return {
          system_operations_forcePaymentDate,
          system_operations_minimunDays,
          pruffConnect_operations_uploadPdfMandatory,
        };
      }
      ({
        system_operations_forcePaymentDate,
        system_operations_minimunDays,
        pruffConnect_operations_uploadPdfMandatory,
      } = await expressGetCompanyConfig(dispatch, user.clientId, [
        'system_operations_forcePaymentDate',
        'system_operations_minimunDays',
        'pruffConnect_operations_uploadPdfMandatory',
      ]));
    } else {
      system_operations_forcePaymentDate = await getCompanyConfigOld(
        dispatch,
        'system_operations_forcePaymentDate',
      );
      system_operations_minimunDays = await getCompanyConfigOld(
        dispatch,
        'system_operations_minimunDays',
      );
      pruffConnect_operations_uploadPdfMandatory = await getCompanyConfigOld(
        dispatch,
        'pruffConnect_operations_uploadPdfMandatory',
      );
    }
    return {
      system_operations_forcePaymentDate,
      system_operations_minimunDays,
      pruffConnect_operations_uploadPdfMandatory,
    };
  };

  const fetchDateRestrictionsConfig = async () => {
    try {
      const {
        system_operations_forcePaymentDate,
        system_operations_minimunDays,
        pruffConnect_operations_uploadPdfMandatory,
      } = await getRestrictions();

      setCanForcePaymentDate(Number(system_operations_forcePaymentDate) === 1);
      setFileStatusMandatory(
        Number(pruffConnect_operations_uploadPdfMandatory) === 1,
      );
      if (system_operations_minimunDays)
        setMinimumDays(Number(system_operations_minimunDays));
    } catch (error) {
      console.error('Error fetching date restrictions config', error);
    }
  };

  useEffect(() => {
    void setUp();
  }, []);

  const buttonText = () => {
    if (validateCompanyTypes(user, 'Accountant')) {
      return 'Enviar solicitud';
    }
    if (validateCompanyTypes(user, 'FactoringQuoting')) {
      return 'Ir a simulador';
    }
  };

  const resetPaymentDates = () => {
    const requestsInvoicesWithDates = [];
    for (const requestInvoice of selectedDocuments) {
      const newRI = {
        ...requestInvoice,
        paymentDate: null,
        dueDate: null,
        daysToCount: 0,
      };
      if (requestInvoice.subDocuments) {
        for (const subDocument of newRI.subDocuments) {
          subDocument.paymentDate = null;
          subDocument.dueDate = null;
          subDocument.daysToCount = 0;
        }
      }
      requestsInvoicesWithDates.push(newRI);
    }
    const tempPaymentDateRows = new Array(selectedDocuments.length).fill(null);
    setTempPaymentDateRows(tempPaymentDateRows);
    const tempSubDocumentPaymentDateRows = selectedDocuments.map(
      (document: any) =>
        new Array(
          document.subDocuments ? document.subDocuments.length : 0,
        ).fill(null),
    );
    setTempSubDocumentPaymentDateRows(tempSubDocumentPaymentDateRows);
    setSelectedDocuments(requestsInvoicesWithDates);
  };

  const checkSelectedDocumentFileStatus = () => {
    if (!fileStatusMandatory) return true;
    return selectedDocuments.every((document: any) => {
      return document.fileStatus;
    });
  };

  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [tempDateString, setTempDateString] = useState<string>('');

  useEffect(() => {
    if (openEditDialog) {
      setTempDateString(operationDate ? formatDate(operationDate) : '');
    }
  }, [openEditDialog, operationDate]);

  const handleEditOperationDate = (event: any) => {
    // Can be less than issued date form document
    const inputValue = event.target.value;
    setTempDateString(inputValue);
  };

  const handleConfirmOperationDate = () => {
    if (!tempDateString) {
      alert('Por favor ingrese una fecha válida');
      return;
    }

    const inputDate = new Date(tempDateString);
    if (isNaN(inputDate.getTime())) {
      alert('Por favor ingrese una fecha válida');
      return;
    }

    for (const document of selectedDocuments) {
      if (inputDate < new Date(document.issuedDate)) {
        alert('La fecha de solicitud no puede ser menor a la fecha de emisión');
        return;
      }
    }
    // We have to reset the document dates
    resetPaymentDates();
    // Set to 12:00:00
    inputDate.setUTCHours(12);
    setOperationDate(inputDate);
    setOpenEditDialog(false);
  };

  // Handler para restaurar todos los montos de los documentos a su valor original
  const handleRestartAllDocumentAmounts = () => {
    const newSelectedDocuments = selectedDocuments.map((doc: any) => {
      if (doc.subDocuments && doc.subDocuments.length > 0) {
        return doc;
      }
      if (doc.originalAmount !== undefined) {
        const { amountAvailable, ...rest } = doc;
        return {
          ...rest,
          amount: doc.originalAmount,
          amountAvailable: doc.originalAmount,
          _creditNoteApplied: false,
        };
      }
      return doc;
    });
    setSelectedDocuments(newSelectedDocuments);
  };

  const disabledEditOperationDate =
    validateCompanyTypes(user, 'Accountant') ||
    !validatePermissions(user, 'financing_factoring_edit_operation_date');

  return (
    <div>
      <Dialog
        maxWidth="lg"
        fullWidth
        open={openShoppingCart}
        onClose={() => handleCloseDialog()}
      >
        <DialogTitle>
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            <span style={{ fontWeight: 'bold' }}>
              Solicitud de financiamiento
            </span>
            <span
              style={{
                display: 'flex',
                alignItems: 'center',
                marginLeft: '10px',
              }}
            >
              Fecha de solicitud:
              {operationDate?.toISOString().split('T')[0]}
              <IconButton
                onClick={() => setOpenEditDialog(true)}
                disabled={disabledEditOperationDate}
                style={{ marginLeft: '5px' }}
              >
                <Edit />
              </IconButton>
            </span>
          </div>
        </DialogTitle>

        <div style={{ minHeight: 100 }}>
          {loading ? (
            <CenteredCircularProgress type="dialog" />
          ) : (
            <div>
              <DateSelector
                selectedDocuments={selectedDocuments}
                requestPayers={requestPayers}
                setRequestPayers={setRequestPayers}
                setSelectedDocuments={setSelectedDocuments}
                setTempPaymentDateRows={setTempPaymentDateRows}
                tempPaymentDateRows={tempPaymentDateRows}
                setTempSubDocumentPaymentDateRows={
                  setTempSubDocumentPaymentDateRows
                }
                tempSubDocumentPaymentDateRows={tempSubDocumentPaymentDateRows}
                backwards={backwards}
                canForcePaymentDate={canForcePaymentDate}
                minimumDays={minimumDays}
                fileStatusMandatory={fileStatusMandatory}
                operationDate={operationDate}
                setOperationDate={setOperationDate}
              />
              {operationDateNotToday() && (
                <DialogContent>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={confirmOperationDateNotToday}
                        onChange={() =>
                          setConfirmOperationDateNotToday(
                            !confirmOperationDateNotToday,
                          )
                        }
                      />
                    }
                    label="Confirmar que la fecha de solicitud no es hoy"
                  />
                </DialogContent>
              )}
              {hasDocumentsWithCreditNotes() && (
                <DialogContent>
                  <div
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                    }}
                  >
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={confirmCreditNotesDiscount}
                          disabled={!hasUnappliedCreditNotes()}
                          onChange={() =>
                            setConfirmCreditNotesDiscount(
                              !confirmCreditNotesDiscount,
                            )
                          }
                        />
                      }
                      label={
                        hasUnappliedCreditNotes()
                          ? 'Confirmar que no deseo descontar las notas de crédito de los documentos seleccionados'
                          : 'Todas las notas de crédito han sido descontadas'
                      }
                    />
                    <LightTooltip
                      title={
                        <Typography style={{ padding: '8px' }}>
                          Restaurar todos los montos a su valor original.
                        </Typography>
                      }
                      placement="top"
                    >
                      <span>
                        <IconButton
                          aria-label="restart amounts"
                          color="primary"
                          style={{ cursor: 'pointer' }}
                          disabled={
                            !hasAnyPermissions(user, [
                              'financing_factoring_edit_documents_amount',
                            ]) ||
                            !selectedDocuments.some(
                              (doc: any) =>
                                doc.originalAmount !== undefined &&
                                doc.amount !== doc.originalAmount &&
                                (!doc.subDocuments ||
                                  doc.subDocuments.length === 0),
                            )
                          }
                          onClick={handleRestartAllDocumentAmounts}
                        >
                          <RestartAlt />
                        </IconButton>
                      </span>
                    </LightTooltip>
                  </div>
                </DialogContent>
              )}
              <DialogActions>
                <CustomButton
                  onClick={() => handleBackwards()}
                  color="secondary"
                >
                  {validateCompanyTypes(user, 'Accountant') ? 'Salir' : 'Atrás'}
                </CustomButton>
                <CustomButton
                  color="primary"
                  disabled={stepChecker()}
                  onClick={() => handleFoward()}
                >
                  {buttonText()}
                </CustomButton>
              </DialogActions>
            </div>
          )}
        </div>
        <Dialog
          open={openEditDialog}
          onClose={() => {
            setOpenEditDialog(false);
            setTempDateString('');
          }}
        >
          <DialogTitle>Editar fecha de solicitud</DialogTitle>
          <DialogContent style={{ paddingTop: 12 }}>
            <TextField
              fullWidth
              label="Fecha de solicitud"
              type="date"
              value={tempDateString}
              onChange={handleEditOperationDate}
            />
          </DialogContent>
          <DialogActions>
            <CustomButton
              color="secondary"
              onClick={() => {
                setOpenEditDialog(false);
                setTempDateString('');
              }}
            >
              Cancelar
            </CustomButton>
            <CustomButton color="primary" onClick={handleConfirmOperationDate}>
              Confirmar
            </CustomButton>
          </DialogActions>
        </Dialog>
      </Dialog>
    </div>
  );
};

export default ShoppingCartFactoring;
